import React, {useEffect, Fragment} from "react";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {getFilteredFeatures, getShippingSetupList} from "../featuresFunctions";
import {FormattedMessage} from "react-intl";
import {percentage} from "../../../misc";

const FeaturesSetupShippingSetupPopupList = (props) => {

  const {featuresList, contextState, contextDispatch, contextAction} = props;
  const {activeShippingCostIndex, shippingSetupList, applyToValue, upDownCheckboxValue, markUpDownInputValue,
    currencyPercentageCheckboxValue} = contextState;

  useEffect(() => {
    contextDispatch(contextAction({
      shippingSetupList: getShippingSetupList(featuresList, applyToValue),
    }))
  }, [applyToValue])

  const shippingCostListItemClick = (delivery, deliveryIndex) => {
    contextDispatch(contextAction({
      activeShippingCostIndex: deliveryIndex,
      shippingCostValue: delivery.shippingCost
    }))
  }

  return (
    <ul className="ui-mark-list">
      {shippingSetupList.map((delivery, deliveryIndex) => {
        if (applyToValue && (delivery.useProperty !== applyToValue)) { // this prevents redundant re-render
          return null
        }
        const property = applyToValue || "shippingCost";
        let displayValue = delivery[property];
        if (markUpDownInputValue && applyToValue && (deliveryIndex === activeShippingCostIndex)) {
          const changeValue = (currencyPercentageCheckboxValue === "percentage")
            ? percentage(+displayValue, +markUpDownInputValue)
            : +markUpDownInputValue;
          displayValue = upDownCheckboxValue === "up" ? +(delivery[property]) + changeValue : +(delivery[property]) - changeValue;
          displayValue = displayValue < 0 ? 0 : +(displayValue.toFixed(2));
        }

        const title = property === "price"
          ? null
          : delivery.shippingName || <FormattedMessage id="features.setup.shippingSetupPopup.notSelected"/>

        const subTitle = property === "price" ?
          delivery.features.length === 1
            ? delivery.features[0].sku
            : "-"
          : delivery.shippingTime || "-"

        return (
          <li className={"ui-mark-list__item" + (deliveryIndex === activeShippingCostIndex ? " ui-mark-list__item--selected" : "")}
               key={delivery[property]}
               onClick={() => shippingCostListItemClick(delivery, deliveryIndex)}>
            <div className="ui-mark-list__item-cell">
              <span className="stone-filter-price-adj-lir__title">
                {title}
                {title ? ": " : null}
                {displayValue
                  ? "$" + displayValue
                  : <FormattedMessage id="features.setup.shippingSetupPopup.free"/>}
              </span>
              <p className="stone-filter-price-adj-lir__date">{subTitle}</p>
            </div>
            <div className="ui-mark-list__item-cell">
              <span className="ui-mark-list__item-count">{delivery.features.length}</span>
            </div>
            <div className="ui-mark-list__item-cell">
              <button className="stone-filter-trashcan-icon"/>
            </div>
          </li>
        )
      })}
    </ul>
  )
};

FeaturesSetupShippingSetupPopupList.propTypes = {
  contextDispatch: PropTypes.func,
  contextAction: PropTypes.func,
  contextState: PropTypes.object
}

const mapStateToProps = (store) => {
  const featuresList = getFilteredFeatures(store, false, true);
  const selectedFeaturesList = getFilteredFeatures(store, true, true);

  return {
    featuresList,
    selectedFeaturesList,
  };
};

const mapDispatchToProps = {
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupShippingSetupPopupList)
)
